import { GlobalState } from '../../store/types';

export const getUIConfigurations = (state: GlobalState) =>
  state.uiConfigurations;
